import React from 'react';
import {Button, Col, Row} from 'antd';
import {marginBottom, marginLeft, marginTop} from "../../common/script";
import {concatInfoList} from "../../api/dataCommon";
import {ArrowRightOutlined} from '@ant-design/icons'


export default class IndexPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            bannerList: [{
                icon: 'images/ic_business.png',
                title: 'Professional',
                info: 'With professional, customized, high-end, intelligent distribution management capabilities'
            }, {
                icon: 'images/ic_new.png',
                title: 'Innovative',
                info: 'Transportation products and modes with combined transportation and distribution capabilities and alienated services'
            }, {
                icon: 'images/ic_group.png',
                title: 'Teamwork',
                info: 'A highly competitive and professional operation team'
            }],
            detailMenuList: [{
                img: 'https://qiniu.mrcargo.com/zs-index-business.png',
                info: "ZEUS creates customized, end-to-end supply chain and logistics solutions for retailers and manufacture enterprise worldwide，giving the expertise and extensive network of supply chain partners needed to meet the diverse needs of our global customers.",
                title: 'Our Business',
                navigateUrl: '/ourBusiness',
                bgColor: '#252724',
            }, {
                img: 'https://qiniu.mrcargo.com/zs-index-e-commence.png',
                info: "ZEUS supply chain technology provides customized online booking and logistics tracking solutions.Ship faster, track better, and streamline the process all while saving time and money.",
                title: 'E-commence Solution',
                navigateUrl: '/eCommence',
                bgColor: '#995611',
            }, {
                img: 'https://qiniu.mrcargo.com/zs-index-platform.png',
                info: "Our goal is to fully digitalize each step of the supply chain so data can flow seamlessly, providing end-to-end visibility for our customers, suppliers.",
                title: 'Digital Platform',
                navigateUrl: '/digitalPlatForm',
                bgColor: '#02356C',
            }, {
                img: 'https://qiniu.mrcargo.com/zs-index-warehousing.png',
                info: "Meet the needs of cross-border business in export collection, import bonded, retail warehousing, various categories of customs declaration and warehouse information management, and make customers feel at ease.",
                title: 'Warehousing',
                navigateUrl: '/warehouse',
                bgColor: '#91806D',
            }]
        }
    }


    render() {
        return (<div>
                <div style={{position: 'relative'}} className={'flex-row width100p'}>
                    <img src={"https://qiniu.mrcargo.com/zs-index-banner.png"} alt={'zs_web_home'}
                         className={'width100p'}/>
                    <Row className={'first-context width100p'}>
                        <Col className={' colorfff'} style={marginTop(10)} offset={4} span={10}>
                            <div className={'font-size40  font-bold'}>ZEUS， Your Logistics Partner</div>
                            <div className={'font-size16'} style={marginTop(3)}>Professional customer service personnel
                                and
                                operators with rich logistics experience can
                                provide customers with customs clearance, transportation, distribution, one-stop service
                                and
                                value-added services.
                            </div>
                            <Button type="primary" shape="default" size={'large'} className={'concat-btn'}
                                    style={marginTop(4)} onClick={() => {
                                this.props.navigationRoute('/company')
                            }}>View more</Button>
                        </Col>
                    </Row>
                </div>
                <Row justify={'center'} className={'bg-f5f7fa'}>
                    {
                        this.state.bannerList.map((item, index) => {
                            return <Col key={`bannerList${index}`} span={index === 1 ? 4 : 5}
                                        offset={index === 0 ? 0 : 1}
                                        style={Object.assign(marginTop(6), marginBottom(6))}>
                                <img src={item.icon} alt={item.icon}/>
                                <div className={'font-size32'} style={marginTop(2)}>{item.title}</div>
                                <div className={'color666666'} style={marginTop(3)}>{item.info}</div>
                            </Col>
                        })
                    }
                </Row>
                {
                    this.state.detailMenuList.map((item, index) => {
                        return this.contentItemView(item, index);
                    })
                }
                <div style={{position: 'relative'}} className={'flex-row width100p'}>
                    <img src={'https://qiniu.mrcargo.com/zs-index-touch.png'} alt={'zs-index-touch'}
                         width={'100%'}/>
                    <div className={'width100p  first-context'}>
                        <div style={Object.assign(marginLeft(40), marginTop(2))}>
                            <div className={'font-size40 colorfff font-weight400'} style={marginTop(6)}>Get in touch
                            </div>
                            {
                                concatInfoList.map((item, index) => {
                                    return <Row key={`concatInfoList${index}`} style={marginTop(index === 0 ? 5 : 4)}>
                                        <Col span={2} className={'colorDefault'}>{item.label}：</Col>
                                        <Col span={4} className={'colorfff'}>
                                            {
                                                item.value.map((info, _) => {
                                                    return <div key={info}>{info}</div>
                                                })
                                            }
                                            {
                                                index === concatInfoList.length - 1 ?
                                                    <Button type="primary" shape="default" size={'large'}
                                                            className={'concat-btn'}
                                                            style={marginTop(5)} onClick={() => {
                                                        this.props.navigationRoute('/concatUs')
                                                    }
                                                    }>Need to contact <ArrowRightOutlined/></Button> : ""
                                            }
                                        </Col>
                                    </Row>
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    /**
     * 内容列表布局
     */
    contentItemView(item, index) {
        return <div className={(index % 2 === 1 ? 'bg-f5f7fa' : 'bg-fff')} style={{position: 'relative'}} key={index}>
            <Row key={`right${index}`} className={'colorfff'}>
                <Col offset={4} span={16} style={Object.assign(marginTop(6), marginBottom(6))}>
                    <div className={'font-size40 color0D182B font-weight400'}>{item.title}</div>
                    <div className={'flex-row ' + (index % 2 === 0 ? 'flex-row-reverse' : '')}
                         style={Object.assign(marginTop(3), {background: item.bgColor})}>
                        <img src={item.img} alt={item.img} width={'50%'}/>
                        <div style={{width: '50%'}}>
                            <div className={''} style={Object.assign({width: '80%'}, marginLeft(5))}>
                                <div>{item.info}</div>
                                {
                                    this.lineOrMoreView(item.navigateUrl)
                                }
                            </div>

                        </div>
                    </div>
                </Col>
            </Row>
            {
                index % 2 === 1 ? <div>
                    <img src={'images/ic_index_circle.png'} alt={'ic_index_circle'} style={rightTopImg}/>
                    <img src={'images/ic_index_circle_left.png'} alt={'ic_index_circle_left'} style={leftImg}/>
                    <img src={'images/ic_index_circle_right.png'} alt={'ic_index_circle_right'} style={rightBottomImg}/>
                </div> : ''
            }
        </div>
    }


    lineOrMoreView(navigateUrl) {
        if (navigateUrl) {
            return <div className={'flex-row pointer-view'} style={marginTop(4)} onClick={() => {
                this.props.navigationRoute(navigateUrl)
            }}>
                <div className={'colorfff'}>View More</div>
                <img style={marginLeft(1)} src={'images/ic_right.png'} alt={'ic_right'}/>
            </div>
        }
        return <div className={'line-view'} style={marginTop(4)}/>
    }
}

const rightTopImg = {
    position: 'absolute',
    right: '5%',
    top: '64px',
}

const rightBottomImg = {
    position: 'absolute',
    right: '-100px',
    top: '30%',
}

const leftImg = {
    position: 'absolute',
    left: '-100px',
    bottom: '-30px',
}






